var e = {
	profile: {
		messageHost: "Message host",
		speaksLanguages: "Speaks {{languages}}",
		hostType: {
			individual: "Individual host",
			business: "Business host"
		},
		badges: {
			identityVerified: "Identity verified",
			businessVerified: "Business verified"
		},
		stats: {
			ratingReviews_one: "{{rating}} · {{count}} review",
			ratingReviews_other: "{{rating}} · {{count}} reviews",
			listings_one: "{{count}} listing",
			listings_other: "{{count}} listings",
			staysHosted_one: "{{count}} stay hosted",
			staysHosted_other: "{{count}} stays hosted",
			hostingSince: "Hosting since {{date}}"
		},
		carousels: {
			listings: "Listings",
			guides: "Travel guides",
			reviews: "Reviews"
		},
		seeAll: "See all",
		reputation: {
			title: "How guests rate {{name}}",
			replyRate: "Replies to {{percent}}% of reviews"
		},
		cityListings: {
			title: "{{name}} listings in {{city}}",
			elsewhere: "{{name}} listings elsewhere"
		}
	},
	meetYourHost: {
		stats: {
			reviews: "Reviews",
			rating: "Rating",
			yearsHosting_one: "Year hosting",
			yearsHosting_other: "Years hosting",
			monthsHosting_one: "Month hosting",
			monthsHosting_other: "Months hosting",
			newHost: "New host"
		},
		verified: {
			title: "{{name}} is a verified host",
			identity: "Maat has confirmed their government-issued identity document.",
			business: "Maat has confirmed their business registration."
		},
		places: {
			oneCity_one: "Hosts {{count}} place in {{city}}",
			oneCity_other: "Hosts {{count}} places in {{city}}",
			twoCities_one: "Hosts {{count}} place in {{city}} and {{secondCity}}",
			twoCities_other: "Hosts {{count}} places in {{city}} and {{secondCity}}",
			manyCities_one: "Hosts {{count}} place in {{city}}, {{secondCity}} and {{more}} more",
			manyCities_other: "Hosts {{count}} places in {{city}}, {{secondCity}} and {{more}} more"
		},
		paymentSafety: "To help protect your payment, always use Maat to send money and communicate with hosts.",
		showMore: "Show more",
		responseRate: "Response rate: {{rate}}%",
		quotes: {
			title: "What guests are saying about {{name}}",
			showAll_one: "Show all {{count}} review",
			showAll_other: "Show all {{count}} reviews",
			showAllForTopic_one: "Show the only {{topic}} review",
			showAllForTopic_other: "Show all {{count}} {{topic}} reviews"
		}
	},
	listings: {
		pageTitle: "{{name}} · Listings",
		empty: "This host has no listings available right now.",
		cityCount_one: "{{count}} city",
		cityCount_other: "{{count}} cities",
		otherCity: "Other",
		pageTitleInCity: "{{name}} listings in {{city}}"
	},
	guides: {
		pageTitle: "{{name}} · Travel guides",
		empty: "This host hasn't published any guides yet."
	},
	reviews: {
		pageTitle: "{{name}} · Reviews",
		empty: "This host has no reviews yet."
	},
	linkRow: { hostedBy: "Hosted by" }
};
//#endregion
export { e as default };
